import containers from './containers'
import forms from './forms'
import loaders from './loaders'
import Ripple from './ripple'
import type { App } from 'vue'

const components = {
    ...containers,
    ...loaders,
    ...forms,
}

const directives = [Ripple]

const install = (app: App) => {
    Object.values(directives).forEach((directive) => {
        app.directive(directive.name, directive.logic)
    })

    Object.keys(components).forEach((componentName) => {
        app.component(componentName, components[componentName as keyof typeof components])
    })
}

export default install
